import React from 'react';

import './App.css';
import Carousel from './Components/Carousel/Carousel';

const App = () => <Carousel />;

export default App;
